import { render, staticRenderFns } from "./AskingPriceHistogram.vue?vue&type=template&id=20ef7c7e&"
import script from "./AskingPriceHistogram.vue?vue&type=script&lang=js&"
export * from "./AskingPriceHistogram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports